import {put, select, takeLatest} from 'redux-saga/effects';
import {setProgramMetadataQueryStart} from "../actions/ProgramMetadataAction";
import {
    DEFINED_PRODUCT_UPDATE,
    getUpdateQueryProductSuccessAction,
    QueryProductUpdateAction,
    SELECTED_PRODUCT_UPDATE,
} from "src/actions/QueryProductUpdateAction";
import {setProgramFeesQueryStart} from "src/actions/ProgramFeesQueryAction";
import {defaultIndexedPrograms, getDefaultProgramParam, isLoginMode, isWidget} from "src/config/Config";
import {setNewProgramFeesQueryStart} from "src/actions/NewProgramFeesQueryAction";
import {UpdateQueryProductResponse} from "src/model/QueryProduct";
import {setRecommendationQueryStart} from "src/actions/RecommendationQueryAction";
import GetUserPreferenceResponse from "src/model/UserPreference";
import RequestStatus from "src/model/RequestStatus";
import ApplicationState from "src/model/ApplicationState";
import {setUserInputQueryStart} from "src/actions/UserInputAction";
import {setCurrentCostQueryStart} from "@amzn/seller-provided-costs-component";

export const getUserPreference = (state: ApplicationState) => state.userPreferenceRes;
export function* updateQueryProductData(action: QueryProductUpdateAction) {
    try {
        const userPreferenceResponse: GetUserPreferenceResponse = yield select(getUserPreference);
        const recommendationEnabled: boolean = userPreferenceResponse && userPreferenceResponse.requestStatus === RequestStatus.SUCCESS
            && userPreferenceResponse.data.recommendationEnabled;
        const autoSaveInputsEnabled: boolean = userPreferenceResponse && userPreferenceResponse.requestStatus === RequestStatus.SUCCESS
            && userPreferenceResponse.data.autoSaveInputs;
        const response: UpdateQueryProductResponse = {
            countryCode: action.countryCode,
            queryProduct: action.queryProduct
        };
        yield put(getUpdateQueryProductSuccessAction(response));
        yield put(setProgramMetadataQueryStart(action.countryCode, action.queryProduct));
        if (!action.queryProduct.isNewDefined) {
            if (isLoginMode() && !isWidget()) {
                if (recommendationEnabled) {
                    yield put(setRecommendationQueryStart(action.countryCode, action.queryProduct.asin));
                }
            }
            if (!isWidget()) {
                // widget has called before get product info
                if (autoSaveInputsEnabled && !!action.queryProduct.merchantSku) {
                    yield put(setUserInputQueryStart(action.queryProduct.asin || "",
                        action.queryProduct.merchantSku || "null", action.countryCode));
                }
                if (isLoginMode()) {
                    yield put(setCurrentCostQueryStart(action.queryProduct.merchantSku || action.queryProduct.asin || "", action.countryCode));
                }
                yield put(setProgramFeesQueryStart(action.countryCode, action.queryProduct, defaultIndexedPrograms,
                    getDefaultProgramParam(defaultIndexedPrograms, action.countryCode)));
            } else {
                yield put(setCurrentCostQueryStart(action.queryProduct.merchantSku || action.queryProduct.asin || "", action.countryCode))
            }
        } else {
            yield put(setNewProgramFeesQueryStart(action.countryCode, action.queryProduct, defaultIndexedPrograms,
                getDefaultProgramParam(defaultIndexedPrograms, action.countryCode)));
        }
    } catch (error) {
        console.error("UpdateQueryProductData error" + error)
        return;
    }

}

export default function* queryProductData() {
    yield takeLatest([DEFINED_PRODUCT_UPDATE, SELECTED_PRODUCT_UPDATE], updateQueryProductData);
}
